import React from 'react';
import CenterSpinner from '../../../../general/Loadings/CenterSpinner';
import PropTypes from 'prop-types';

const CreateRule = React.lazy(() => import('./CreateRule'));
const EditRule = React.lazy(() => import('./EditRule'));

const DataActionRule = ({ id, currentRule }) => {
     return (
          <div className='rule-detail'>
               <React.Suspense fallback={<CenterSpinner />}>{id ? <EditRule id={id} currentRule={currentRule} /> : <CreateRule />}</React.Suspense>
          </div>
     )
};


DataActionRule.propTypes = {
     currentRule: PropTypes.any,
     id: PropTypes.string,
};

export default DataActionRule;
